import Axios from 'axios';
import Vue from 'vue';
import i18n from '../../../i18n';
import { API_HOST } from '../../../config/app-const';

const state = {
  editorProjectSettings: {
    isBusy: false,
    data: null,
    error: null
  }
};

const mutations = {
  LOAD_PROJECT_SETTINGS_BUSY: (state, payload) => {
    state.editorProjectSettings.isBusy = payload;
  },
  LOAD_PROJECT_SETTINGS_SUCCESS: (state, payload) => {
    state.editorProjectSettings.data = payload.data;
    state.editorProjectSettings.error = null;
  },
  LOAD_PROJECT_SETTINGS_FAIL: (state, payload) => {
    state.editorProjectSettings.data = null;
    state.editorProjectSettings.error = payload;
  }
};

const actions = {
  getProjectSettings: ({ commit, rootState }, { projectId }) => {
    commit('LOAD_PROJECT_SETTINGS_BUSY', true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    Axios
      .get(`${API_HOST}/analysis/editor/${projectId}/settings`, config)
      .then(response => {
        commit('LOAD_PROJECT_SETTINGS_SUCCESS', response.data)
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});

        console.error(error);
        commit('LOAD_PROJECT_SETTINGS_FAIL', error)
      })
      .finally(() => commit('LOAD_PROJECT_SETTINGS_BUSY', false));
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};